import { FromTo } from '@/modules/projects/components/Workbench/FromTo'
import { Warnings } from '@/modules/projects/components/Workbench/Warnings'
import { WhatChanges } from '@/modules/projects/components/Workbench/WhatChanges'
import type { EditPreview } from '@/modules/projects/stores/types'
import { fileLine, pairsOf, whatChanges } from './preview'

export const EditPreviewBody = ({
  preview,
  showsVerdict,
  showsSubject = false,
}: {
  preview: EditPreview
  showsVerdict: boolean
  // Several edits about several statements, such as a re-cut of two files, each name their own.
  showsSubject?: boolean
}) => (
  <div className="space-y-4">
    {showsSubject && preview.subject ? (
      <p className="truncate text-xs font-semibold text-neutral-600">
        {fileLine(preview.subject)}
      </p>
    ) : null}

    {pairsOf(preview).map((pair) => (
      <FromTo
        key={`${pair.label}${pair.from.headline}`}
        label={pair.label}
        from={pair.from}
        to={pair.to}
      />
    ))}

    <Warnings warnings={preview.warnings} />
    <WhatChanges lines={whatChanges(preview, showsVerdict)} />
  </div>
)
